import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './Body.module.scss';

interface Props {
    children: ReactNode;
    className?: string;
    isCentered?: boolean;
}

export function Body({ children, className, isCentered }: Props) {
    const WrapperTag = typeof children === 'string' ? 'p' : 'div';

    return (
        <WrapperTag
            className={classNames(styles.body, className, { [styles.centered]: isCentered })}
        >
            {children}
        </WrapperTag>
    );
}
